exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-width input {\n    box-sizing: border-box;\n    padding: 10px;\n    height: 2.5rem;\n    border-radius: 4px;\n    border: 1px solid rgb(206, 206, 206);\n}\n\n::ng-deep .mat-form-field-infix {\n    margin-top: 5px;\n}\n\n::ng-deep .mat-form-field-wrapper {\n    padding-bottom: 0;\n}\n\n::ng-deep .input-radio .mat-form-field-label {\n    box-sizing: border-box;\n    padding: 10px;\n}\n\n.info-codigo-acesso p {\n  margin-top: 0px;\n  margin-bottom: 10px;\n  font-weight: 500;\n  color: #5b5b5b;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-radio/bra-radio.component.css
// module id = ../../../../../src/app/componentes/bra-radio/bra-radio.component.css
// module chunks = main